import * as Yup from "yup";


export const StrategyName = Yup.object({
  name: Yup.string().min(1).max(30).required("strategy name is required"),
  description: Yup.string().min(5),
});

// tags/categories per item: max 30 chars
// tags array: max 20 items
// categories array: max 10 items
export const tagItemSchema = Yup.string()
  .min(2, "Each tag must be at least 2 characters")
  .max(30, "Each tag must be 30 characters or fewer");

export const categoryItemSchema = Yup.string()
  .min(2, "Each category must be at least 2 characters")
  .max(30, "Each category must be 30 characters or fewer");

export const StrategySchema = Yup.object({
  name: Yup.string().min(1).max(30).required("Strategy name is required"),
  description: Yup.string().min(5),
  tags: Yup.array()
    .of(tagItemSchema)
    .max(20, "You can add up to 20 tags"),
  categories: Yup.array()
    .of(categoryItemSchema)
    .max(10, "You can add up to 10 categories"),
});

